//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { QueryRenderer, ReadyState } from "react-relay";
// profile-user-summary-renderer imports
import { IRendererProps, IRendererContainer } from "./ProfileUserSummary.d";
import { profileUserSummaryQuery } from "./ProfileUserSummaryRenderer.gql";
import * as s from "./ProfileUserSummary.styles";
// other internals
import { ProfileUserSummary } from "./ProfileUserSummary";
import { IReduxState } from "@reducers/root.reducer";
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
import { H2 } from "@ui";
// util
import { getFetchInfo } from "@util/team-health.util";
import { handleReadyStateError } from "@util/relay.util";

//////////////////
// COMPONENT
//////////////////
class ProfileUserSummaryRendererCmpt extends React.PureComponent<IRendererProps> {
  // not on state b/c we don't want this to trigger a re-render
  private cachedOrg: ISchema.IOrg | undefined;
  private cachedCalendarId: string | undefined;

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  public render() {
    const { orgRelayId, calendarId, chromeCalendarView, environment } = this.props;
    const { fetchVariables } = getFetchInfo(orgRelayId, chromeCalendarView);

    const calendarIds = [calendarId];

    return (
      <QueryRenderer
        environment={environment}
        query={profileUserSummaryQuery}
        variables={{
          orgRelayId,
          calendarId,
          calendarIds,
          timeZone: fetchVariables.timeZone,
          rangeMin: fetchVariables.rangeMin,
          rangeMax: fetchVariables.rangeMax,
        }}
        cacheConfig={{}}
        render={(readyState: ReadyState) => {
          // get cached stuff
          const freshOrg = readyState.props && readyState.props.org;
          const org = freshOrg || this.cachedOrg;
          const showLoader = !org || calendarId !== this.cachedCalendarId;

          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "ProfileUserSummaryRenderer");

            return <H2 style={s.label}>Profile</H2>;
          }

          // loading for the first time
          if (showLoader) {
            // reset cache
            this.cachedCalendarId = calendarId;
            this.cachedOrg = undefined;

            // show loader
            return (
              <div style={s.container}>
                <div style={s.loading}>
                  <CircularProgress />
                </div>
              </div>
            );
          }

          this.cachedOrg = org;
          return <ProfileUserSummary org={org} calendarId={calendarId} />;
        }}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////
export const ProfileUserSummaryRenderer = connect(
  (state: IReduxState, _ownProps: IRendererContainer) => ({
    calendarId: state.webExtension.activeViewCalendarProfile.calendarId,
    chromeCalendarView: state.webExtension.calendarView,
  }),
  {},
)(ProfileUserSummaryRendererCmpt);
